const INSTAGRAM_USERNAME_RE =
  /^(?:@|(?:https?:\/\/)?(?:www\.)?instagr(?:\.am|am\.com)\/)?(\w+)\/?$/

export const getInstagramUsername = (value: string): string => {
  const match = INSTAGRAM_USERNAME_RE.exec(value)
  if (match?.[1]) return match[1]
  return value
}
